module.exports = "<nv-react-component component=\"ProgressiveQuizModal\" inline=\"true\"></nv-react-component>";